import { render } from "./VStatus.vue?vue&type=template&id=893b13b8"
import script from "./VStatus.vue?vue&type=script&lang=js"
export * from "./VStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__